<template>
  <div>
    <component
      v-bind="labelItem.option"
      :is="propsComponent"
      v-model="input"
      :disabled="computedDisabled"
      :placeholder="computedPlaceholder"
      :label-item="labelItem"
      :clearable="true"
      v-on="labelItem.event"
      @upload-success="(res)=>{$emit('upload-success',res)}"
    >
    </component>
  </div>
</template>
<script>
import templateFormUpload from './template-form-upload'
import templateFormTable from './template-form-table'
export default {
  components: {
    templateFormUpload,
    templateFormTable
  },
  props: {
    value: {
      type: String,
      required: true
    },
    labelItem: {
      type: Object,
      required: () => {
        return {
          id: null,
          name: null
        }
      }
    }
  },
  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    propsComponent() {
      let type = 'cube-input'
      switch (this.labelItem.type) {
        case 'input':
          type = 'cube-input'
          break
        case 'number':
          type = 'cube-input-number'
          break
        case 'date':
          type = 'cube-date-picker'
          break
        case 'time':
          type = 'cube-time-picker'
          break
        case 'select':
          type = 'cube-select'
          break
        case 'image':
          type = 'template-form-upload'
          break
        case 'table':
          type = 'template-form-table'
          break
      }
      return type
    },
    computedPlaceholder() {
      return this.labelItem.placeholder || ''
    },
    computedDisabled() {
      const val = this.labelItem.defaultValue
      return val !== null && val !== undefined && val !== ''
    }
  }
}
</script>
